import React from 'react';
import PropTypes from 'prop-types';

/**
 * SimpleTable — the scrollable header+body table shared by the chart "List" view (MiniTable)
 * and DataTable. The caller supplies className strings/resolvers (already run through aphrodite's
 * css()) and the cell formatter so the rendered markup stays byte-identical to the originals.
 *
 *  - wrapClassName / tableClassName / thClassName: plain css() strings
 *  - trClassName(rowIndex):  css(...) string for a body <tr>
 *  - tdClassName(cell):      css(...) string for a body <td>
 *  - fmt(cell):              cell formatter
 */
export default function SimpleTable({
  columns,
  rows,
  wrapClassName,
  tableClassName,
  thClassName,
  trClassName,
  tdClassName,
  fmt,
}) {
  return (
    <div className={wrapClassName}>
      <table className={tableClassName}>
        <thead>
          <tr>
            {columns.map(c => (
              <th key={c} className={thClassName}>
                {c}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((r, ri) => (
            // eslint-disable-next-line react/no-array-index-key
            <tr key={ri} className={trClassName(ri)}>
              {r.cells.map((cell, ci) => (
                // eslint-disable-next-line react/no-array-index-key
                <td key={ci} className={tdClassName(cell)}>
                  {fmt(cell)}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
SimpleTable.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.string).isRequired,
  rows: PropTypes.arrayOf(PropTypes.object).isRequired,
  wrapClassName: PropTypes.string.isRequired,
  tableClassName: PropTypes.string.isRequired,
  thClassName: PropTypes.string.isRequired,
  trClassName: PropTypes.func.isRequired,
  tdClassName: PropTypes.func.isRequired,
  fmt: PropTypes.func.isRequired,
};
